export default __webpack_public_path__ + "resources/icons/d0-2e8a.webp";